import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp, mediaQueryOnly } from 'components/utils/breakpoint'
import Pane from 'components/Common/Pane'

export const NavWrapper = styled(Pane)`
  display: flex;
  height: ${rem(64)};
  overflow-x: visible;

  ${mediaQueryUp.md} {
    height: ${rem(60)};
  }
`

export const HiddenTablet = styled.span`
  ${mediaQueryOnly.sm} {
    display: none;
  }
`

export const SummaryColumn = styled.div`
  flex: 1 1 auto;

  > * + * {
    margin-top: ${rem(16)};
  }

  ${mediaQueryUp.xs} {
    margin-left: auto;

  }

  ${mediaQueryUp.sm} {
    flex: 1 0 ${rem(400)};
    border-bottom: 0;
  }
`
